import React, { createContext, useState } from 'react';
const GlobalContext = createContext();

const GlobalContextProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(-1);
  const [cartDrawer, setCartDrawer] = useState(-1);
  const [brandList, setBrandList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [products, setProducts] = useState([]);
  const [firstHit, setFirstHit] = useState(false);
  const [productToCart, setProductsToCart] = useState({});
  const [query, setQuery] = useState("");

  const updateCategoryList = (value) => {
    setCategoryList(value)
  };
  const updateCartCount = (value) => {
    setCartCount(value)
  };

  const updateCartDrawer = (value) => {
    setCartDrawer(prev => prev + 1)
  };
  
  const updateBrandList = (value) => {
    setBrandList(value)
  };
  
  const updateSearchResults = (value) => {
    setSearchResults(value)
  };

  const updateFirstHit = (value) => {
    setFirstHit(value)
  };

  const updateProducts = (value) => {
    setProducts(value);
  }

  const updateQuery = (value) => {
    setQuery(value);
  }
  
  const addProductsToCart = (value) => {
    setProductsToCart(value);
  }

  return (
    <GlobalContext.Provider value={{ categoryList, cartCount, brandList, searchResults, firstHit, products, productToCart, query, cartDrawer, updateCategoryList, updateCartCount, updateBrandList, updateSearchResults, updateFirstHit, updateProducts, addProductsToCart, updateQuery, updateCartDrawer }}>
      {children}
    </GlobalContext.Provider>
  );
};

export { GlobalContext, GlobalContextProvider };